import { render, staticRenderFns } from "./noList.vue?vue&type=template&id=4b221634&"
import script from "./noList.vue?vue&type=script&lang=js&"
export * from "./noList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports